import React from 'react';

const SvgActions23 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 16 20" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M2 18h12v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zM14 2H2V1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1zm2 4v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2zm-2 0H2v8h12z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgActions23 svgRef={ref} {...props} />);
export default ForwardRef;
